module.exports = __webpack_public_path__ + "static/media/starship.9b9e5fa2.svg";